<template>
  <div>
    <div />
  </div>
</template>

<script>
export default {
  name: 'VbCreditNotes',
  components: {},
}
</script>
